import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import YagiChatBotAiResultBubble from '@/components/format-edit/yagi-chat-bot/YagiChatBotAiResultBubble.vue'
import YagiChatBotSystemBubble from '@/components/format-edit/yagi-chat-bot/YagiChatBotSystemBubble.vue'
import type { YagiChatMessage } from '@/utils/format-edit/yagiChatBot'


export default /*#__PURE__*/_defineComponent({
  __name: 'YagiChatBotMessages',
  props: {
    messages: null,
    chatDate: null,
    thinkingMode: { type: Boolean },
    thinkingLabel: null
  },
  emits: ["edit-skipped", "edit-company", "ai-accept", "ai-regenerate", "ai-edit"],
  setup(__props: any, { expose }: { emit: ({
  (e: 'edit-skipped', indices: number[]): void
  (e: 'edit-company', fields: string[]): void
  (e: 'ai-accept'): void
  (e: 'ai-regenerate'): void
  (e: 'ai-edit'): void
}), expose: any, slots: any, attrs: any }) {





const rootEl = ref<HTMLElement | null>(null)

expose({
  rootEl
})

return { __sfc: true,rootEl, YagiChatBotAiResultBubble, YagiChatBotSystemBubble }
}

})